import { ToastUtil } from '../utils/toast.util';
import {
  getThirdPartyIntegrationsWithPaginationApi,
  getThirdPartyIntegrationApi,
  updateThirdPartyIntegrationApi,
  getThirdPartyIntegrationsListApi,
  orderSupplierTaggingApi,
  shipStationSalesOrderNumberMappingApi,
  getShipStationTaggerScheduleApi,
  updateShipStationTaggerScheduleApi,
  getShipStationTaggerProcessStatusApi,
  downloadShipStationTaggerRunReportCsvApi,
} from './third-party-integrations.api';

export const getThirdPartyIntegrationsWithPaginationReducers = (builder) => {
  builder
    .addCase(getThirdPartyIntegrationsWithPaginationApi.pending, (state) => {
      state.getThirdPartyIntegrationsStatus = 'pending';
    })
    .addCase(
      getThirdPartyIntegrationsWithPaginationApi.fulfilled,
      (state, { payload }) => {
        state.getThirdPartyIntegrationsStatus = 'success';
        state.thirdPartyIntegrations = payload.thirdPartyIntegrations;
        state.totalThirdPartyIntegrations = payload.totalCount;
        state.totalPages = payload.totalPages;
        state.currentPage = payload.currentPage;
      },
    )
    .addCase(getThirdPartyIntegrationsWithPaginationApi.rejected, (state, action) => {
      state.getThirdPartyIntegrationsStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const getThirdPartyIntegrationReducers = (builder) => {
  builder
    .addCase(getThirdPartyIntegrationApi.pending, (state) => {
      state.getThirdPartyIntegrationStatus = 'pending';
      state.error = null;
    })
    .addCase(getThirdPartyIntegrationApi.fulfilled, (state, { payload }) => {
      state.getThirdPartyIntegrationStatus = 'fulfilled';
      state.thirdPartyIntegration = payload;
      state.error = null;
    })
    .addCase(getThirdPartyIntegrationApi.rejected, (state, action) => {
      state.getThirdPartyIntegrationStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const updateThirdPartyIntegrationReducers = (builder) => {
  builder
    .addCase(updateThirdPartyIntegrationApi.pending, (state) => {
      state.updateThirdPartyIntegrationStatus = 'pending';
      state.error = null;
    })
    .addCase(updateThirdPartyIntegrationApi.fulfilled, (state, { payload }) => {
      const response = payload;
      state.updateThirdPartyIntegrationStatus = 'fulfilled';
      state.thirdPartyIntegration = payload.data;
      state.error = response.message;

      ToastUtil.handleApiResponse(response, 'Update Successful', 'Update Failed');
    })
    .addCase(updateThirdPartyIntegrationApi.rejected, (state, action) => {
      state.updateThirdPartyIntegrationStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Update failed',
        action?.error?.message || 'Failed to update third party integration',
      );
    });
};

export const getThirdPartyIntegrationsListReducers = (builder) => {
  builder
    .addCase(getThirdPartyIntegrationsListApi.pending, (state) => {
      state.getThirdPartyIntegrationsListStatus = 'pending';
    })
    .addCase(getThirdPartyIntegrationsListApi.fulfilled, (state, { payload }) => {
      state.getThirdPartyIntegrationsListStatus = 'fulfilled';
      state.list = payload;
    })
    .addCase(getThirdPartyIntegrationsListApi.rejected, (state, action) => {
      state.getThirdPartyIntegrationsListStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const orderSupplierTaggingReducers = (builder) => {
  builder
    .addCase(orderSupplierTaggingApi.pending, (state) => {
      state.orderSupplierTaggingStatus = 'pending';
      state.error = null;
    })
    .addCase(orderSupplierTaggingApi.fulfilled, (state, { payload }) => {
      state.orderSupplierTaggingStatus = 'fulfilled';
      state.error = null;

      ToastUtil.success(
        'Tagging Triggered',
        'Order supplier tagging has been triggered successfully',
      );
    })
    .addCase(orderSupplierTaggingApi.rejected, (state, action) => {
      state.orderSupplierTaggingStatus = 'rejected';
      state.error = action?.error?.message;

      ToastUtil.error(
        'Tagging Failed',
        action?.error?.message || 'Failed to trigger manual order supplier tagging',
      );
    });
};

export const shipStationSalesOrderNumberMappingReducers = (builder) => {
  builder
    .addCase(shipStationSalesOrderNumberMappingApi.pending, (state) => {
      state.shipStationSalesOrderNumberMappingStatus = 'pending';
      state.error = null;
    })
    .addCase(shipStationSalesOrderNumberMappingApi.fulfilled, (state, { payload }) => {
      state.shipStationSalesOrderNumberMappingStatus = 'fulfilled';
      state.error = null;

      const result = payload?.data;
      const updatedCount = result?.updatedOrdersCount || 0;
      const failedCount = result?.failedRowsCount || 0;

      if (payload?.success) {
        ToastUtil.success(
          failedCount > 0
            ? 'ShipStation Mapping Partially Completed'
            : 'ShipStation Mapping Completed',
          payload?.message ||
            (failedCount > 0
              ? `Updated ${updatedCount} orders; ${failedCount} row(s) failed`
              : `Updated ${updatedCount} orders successfully`),
        );
      } else {
        ToastUtil.error(
          'ShipStation Mapping Failed',
          payload?.error ||
            payload?.message ||
            (failedCount > 0
              ? `${failedCount} row(s) failed; first error: ${result?.failures?.[0]?.reason || 'Unknown error'}`
              : 'Failed to process sales order number mapping'),
        );
      }
    })
    .addCase(shipStationSalesOrderNumberMappingApi.rejected, (state, action) => {
      state.shipStationSalesOrderNumberMappingStatus = 'rejected';
      state.error = action?.payload?.message || action?.error?.message;

      ToastUtil.error(
        'ShipStation Mapping Failed',
        action?.payload?.message ||
          action?.error?.message ||
          'Failed to process sales order number mapping',
      );
    });
};

export const shipStationTaggerReducers = (builder) => {
  builder
    .addCase(getShipStationTaggerScheduleApi.fulfilled, (state, { payload }) => {
      state.shipStationTaggerSchedule = payload;
      state.getShipStationTaggerScheduleStatus = 'fulfilled';
    })
    .addCase(updateShipStationTaggerScheduleApi.fulfilled, (state, { payload }) => {
      state.shipStationTaggerSchedule = payload;
      state.updateShipStationTaggerScheduleStatus = 'fulfilled';
      ToastUtil.success('Schedule saved', 'ShipStation tagger schedule updated');
    })
    .addCase(getShipStationTaggerProcessStatusApi.fulfilled, (state, { payload }) => {
      state.shipStationTaggerProcessStatus = payload;
      state.isShipStationTaggerRunning = Boolean(payload?.isRunning);
    })
    .addCase(downloadShipStationTaggerRunReportCsvApi.pending, (state) => {
      state.downloadShipStationTaggerReportStatus = 'loading';
    })
    .addCase(downloadShipStationTaggerRunReportCsvApi.fulfilled, (state) => {
      state.downloadShipStationTaggerReportStatus = 'succeeded';
    })
    .addCase(downloadShipStationTaggerRunReportCsvApi.rejected, (state) => {
      state.downloadShipStationTaggerReportStatus = 'failed';
    });
};
